"use client";

import { useState } from "react";

import { type GridProject, ProjectCard } from "./project-card";

// =============================================================================

type ProjectsGridProps = { projects: GridProject[] };

/**
 * Two columns of project cards. While a card is hovered, the others dim so
 * that it stands out.
 */
export function ProjectsGrid({ projects }: ProjectsGridProps) {
  const [activeId, setActiveId] = useState<string | null>(null);

  return (
    <ul className="grid gap-x-6 gap-y-[clamp(3rem,5.6vw,5rem)] md:grid-cols-2">
      {projects.map((project, index) => (
        <ProjectCard
          key={project.id}
          project={project}
          index={index}
          isActive={activeId === project.id}
          isDimmed={activeId !== null && activeId !== project.id}
          onActivate={() => setActiveId(project.id)}
          onDeactivate={() =>
            setActiveId((current) => (current === project.id ? null : current))
          }
        />
      ))}
    </ul>
  );
}

// =============================================================================
